import React from 'react'
import styles from './App.module.scss'
import PresaleContainer from './container/PresaleContainer'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { mainnet, sepolia } from 'wagmi/chains'
import { QueryParamProvider } from 'use-query-params'
import { WagmiProvider } from 'wagmi'
import { createWeb3Modal, defaultWagmiConfig } from '@web3modal/wagmi/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import toast, { ToastBar, Toaster } from 'react-hot-toast'
import { config } from './config.jsx'
import Header from './components/landing/Header.jsx'
import Hero from './components/landing/Hero.jsx'
import Faqs from './components/landing/Faqs.jsx'
import About from './components/landing/About.jsx'
import HowToBuy from './components/landing/HowToBuy.jsx'
import TokenRoadmap from './components/landing/TokenRoadmap.jsx'
import Tokenomics from './components/landing/Tokenomics.jsx'
import Footer from './components/landing/Footer.jsx'
import Sponsers from './components/landing/Sponsers.jsx'

const projectId = '75f0ab21a52cbff7e566bcc9be983646'

const queryClient = new QueryClient()

const metadata = {
  name: 'LNTL',
  description: 'LITTLE PEPE',
  url: 'https://presale.lintelcoin.net',
  icons: ['https://avatars.githubusercontent.com/u/37784886']
}

const chains = [mainnet]

const wagmiConfig = defaultWagmiConfig({ chains, projectId, metadata, auth: {email: false, socials: [], showWallets: true} })

createWeb3Modal({
  themeVariables: {
    '--w3m-accent': '#006C28',
    '--w3m-border-radius-master': '1px',
  },
  projectId,
  metadata,
  wagmiConfig
}
)

const App = () => {
  return (
    <Router>
      <QueryParamProvider>
        <QueryClientProvider client={queryClient}>
          <div className={styles.App}>
            <WagmiProvider reconnectOnMount config={config}>
              <Toaster
                position="top-right"
                reverseOrder={true}
                toastOptions={{ duration: 5000 }}
              >
                {t => (
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => toast.dismiss(t.id)}
                  >
                    <ToastBar onClick={() => alert(1)} toast={t} />
                  </div>
                )}
              </Toaster>
              {/* <Header /> */}
              <Header />
              <Switch>
                <Route exact path="/">
                  {/* <PresaleContainer /> */}
                  <Hero />
                  <Sponsers />
                  <About />
                  <HowToBuy />
                  <TokenRoadmap />
                  <Tokenomics />
                  <Faqs />
                  <Footer />
                </Route>
              </Switch>
            </WagmiProvider>
          </div>
        </QueryClientProvider>
      </QueryParamProvider>
    </Router>
  )
}

export default App
